<template>
    <div>
        <span v-for="(value, index) in list" :key="index">{{ value[field] }}<span v-if="index < list.length - 1">, </span></span>
    </div>
</template>

<script>
    export default {
        name: "CommaSeparatedSpan",

        props: {
            list: {
                type: Array,
                required: true
            },

            field: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped>

</style>
